import React from "react";
import { useEffect, useState, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";

import assets from "../assets";
import { Backdrop, Fade, Modal, Box, IconButton, Button } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import QRCode from "react-qr-code";
import { clientBaseUrl } from "../api/axiosClient";

const baseModalStyle = {
  outline: "none",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%,-50%)",
  width: "400px",
  bgcolor: "background.paper",
  border: "1px solid gray",
  boxShadow: 24,
  p: 1,
  height: "400px",

  backgroundColor: assets.colors.secondaryy,
  overflowX: "none",
  overflowY: "scroll",
  borderRadius: "100px 0px 100px 0px",
  overflow: "hidden",
};

const QrModal = (props) => {
  const [recipe, setRecipe] = useState("");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const modalDimensions = {
    ...baseModalStyle,
    width: isMobile ? "90vw" : baseModalStyle.width,
    height: isMobile ? "auto" : baseModalStyle.height,
    maxHeight: "90vh",
    p: isMobile ? 2 : baseModalStyle.p,
    borderRadius: isMobile ? "32px" : baseModalStyle.borderRadius,
  };

  useEffect(() => {
    setRecipe(props.recipeId);
  }, [props.recipeId]);

  const onClose = async () => {
    try {
      props.onClose();
    } catch (err) {}
  };

  return (
    <>
      <Modal
        open={props.open !== false}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
        onClose={onClose}
      >
        <Fade in={props.open !== false}>
          <Box sx={modalDimensions}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                widht: "100%",
              }}
            >
              <IconButton
                variant="outlined"
                color="error"
                onClick={(e) => {
                  props.onClose();
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                pt: 3,
              }}
            >
              <Box
                sx={{
                  p: 2,
                  backgroundColor: "#fff",
                  borderRadius: 3,
                  boxShadow: "0 10px 30px rgba(15,23,42,0.15)",
                }}
              >
                <QRCode
                  value={clientBaseUrl + "label-generator/" + recipe}
                  size={isMobile ? 180 : 256}
                />
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default QrModal;
